import { dataToolbox } from 'dls-icons-data'
import { createIcon } from '../common'

const IconToolbox = /*#__PURE__*/createIcon(dataToolbox)
export default IconToolbox
